namespace TabAurous.Inventory {
    export interface SKUSplittingForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        AutoPosting: Serenity.BooleanEditor;
        VoucherNo: Serenity.StringEditor;
        Details: SKUSplittingDetailsEditor;
        CommonItemDetails: SKUSplittingCommonEditor;
        UserId: Serenity.IntegerEditor;
        EmployeeId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        CurrencyId: Serenity.IntegerEditor;
        ExchRate: Serenity.DecimalEditor;
    }

    export class SKUSplittingForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.SKUSplitting';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SKUSplittingForm.init)  {
                SKUSplittingForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.StringEditor;
                var w5 = SKUSplittingDetailsEditor;
                var w6 = SKUSplittingCommonEditor;
                var w7 = s.DecimalEditor;

                Q.initFormType(SKUSplittingForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'VoucherTypeId', w2,
                    'AutoPosting', w3,
                    'VoucherNo', w4,
                    'Details', w5,
                    'CommonItemDetails', w6,
                    'UserId', w2,
                    'EmployeeId', w2,
                    'CompanyId', w2,
                    'FinancialYearId', w2,
                    'CurrencyId', w2,
                    'ExchRate', w7
                ]);
            }
        }
    }
}
